// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1BJ9Z","location":"Header_location__2ebti"};